<template>
    <div class="page">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <!-- 搜索框-->
            <el-form-item prop="nameCn">
                <el-input size="small" v-model="searchForm.nameCn" placeholder="中文名称" clearable></el-input>
          </el-form-item>
          <el-form-item prop="nameEn">
                  <el-input size="small" v-model="searchForm.nameEn" placeholder="英文名称" clearable></el-input>
          </el-form-item>
          <el-form-item prop="空间类型">
            <el-select v-model="searchForm.type" placeholder="类型"  style="width: 100%;">
                <el-option
                  v-for="item in $dictUtils.getDictList('sets_type')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
            </el-form-item>
          <el-form-item prop="state">
              <el-select
                  v-model="searchForm.state"
                  clearable
                  placeholder="状态"
                  class="width205"
                >
                  <el-option
                    v-for="item in stateOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                      <div class="flex-js-ac">
                        <div class="point" :class="item.value === '0' ? 'greenBack' : item.value === '1' ? 'redBack' : 'yellowBack'"></div>
                        <span>{{ item.label }}</span>
                      </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="tags">
                <!-- <el-input size="small" class="width205" v-model="searchForm.tags" placeholder="标签" clearable></el-input> -->
                <el-select v-model="searchForm.tagsIdsList" multiple clearable placeholder="标签" class="">
                  <el-option
                    v-for="item in tagList"
                    :key="item.id"
                    :label="item.nameEn"
                    :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
      </el-form>

     <div class="bg-white top">
      <div>
        <span>该模块是用于显示PRODUCT套餐的数据</span>
      </div>
        <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
          <template #buttons>
            <el-button v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
            <!-- <el-button v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmSetMealTable && $refs.cecUnmSetMealTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <el-button v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmSetMealTable && $refs.cecUnmSetMealTable.getCheckboxRecords().length === 0" plain>删除</el-button>
            <el-dropdown v-if="hasPermission('unmarticle:cecUnmArticle:edit')" class="ml8" :split-button="true" size="small" type="primary" icon="el-icon-files" trigger="click"  @command="handDropDownItem" :disabled="$refs.cecUnmSetMealTable && $refs.cecUnmSetMealTable.getCheckboxRecords().length === 0" >
              批量操作
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in stateOption" :key="item.value" :command="item.value">
                  <div class="flex-jc-ac">
                    <div class="point" :class="item.value === '0' ? 'greenBack' : item.value === '1' ? 'redBack' : 'yellowBack'"></div>
                    <span>{{ item.label }}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template #tools>
            <vxe-button
    		  type="default"
    		  title="下载导入模板"
    		  v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:import')"
    		  class="el-icon-document m-r-12"
    		  @click="downloadTpl()"
    		  circle
            >
            </vxe-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 98px);">
        <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecUnmSetMealTable"
            show-header-overflow
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
            :export-config="{
                remote: true,
                filename: `UM套餐表数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: 'UM套餐表数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
            @sort-change="sortChangeHandle"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
            <!-- <vxe-column type="seq" width="40"></vxe-column> -->
            <vxe-column type="checkbox"  width="40px"></vxe-column>
            <vxe-column
        field="sort"
        sortable
        width="70"
        align="center"
        title="排序">
      </vxe-column>
      <vxe-column
        field="state"
        sortable
        align="center"
        width="100"
        title="状态">
        <template slot-scope="scope">
          <!-- {{ scope.row.state === '0' ? '显示' : scope.row.state === '1' ? '禁止' : '草稿' }} -->
          <div class="flex-jc-ac">
            <div class="point" :class="scope.row.state === '0' ? 'greenBack' : scope.row.state === '1' ? 'redBack' : 'yellowBack'"></div>
            <span>{{ scope.row.state === '0' ? '上线' : scope.row.state === '1' ? '下线' : '草稿' }}</span>
          </div>
        </template>
      </vxe-column>
    <vxe-column
        field="nameEn"
        sortable
        min-width="100"
        title="英文名称">
            <template slot-scope="scope">
              <!-- <el-link  type="primary" :underline="false" v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:edit')" @click="edit(scope.row.id)">{{scope.row.nameEn}}</el-link> -->
              <el-link  type="primary" :underline="false" v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:view')"  @click="view(scope.row.id)">{{scope.row.nameEn}}</el-link>
              <span v-else>{{scope.row.nameEn}}</span>
            </template>
      </vxe-column>
    <vxe-column
        field="nameCn"
        sortable
        min-width="100"
        title="中文名称">
      </vxe-column>
      <vxe-column
        field="setsObj"
        sortable
        min-width="100"
        title="关联套餐">
        <template slot-scope="scope">
          <el-link  type="primary" :underline="false" @click="projectEdit(scope.row)">{{ scope.row.setsObj.nameCn }}</el-link>
        </template>
      </vxe-column>
      <vxe-column
        field="tags"
        align="center"
        min-width="100"
        title="标签">
        <template slot-scope="scope">
          <div style="overflow: hidden;">
            <el-tag
              v-for="(tag ,index) in scope.row.tagsList"
              size="mini"
              :key="index"
              class="singleTag"
              style="margin-right: 5px"
            >{{ tag.nameEn }}</el-tag>
          </div>
        </template>
      </vxe-column>
      <vxe-column
        field="type"
        align="center"
        width="80"
        title="类型">
        <template slot-scope="scope">
              {{ $dictUtils.getDictLabel("sets_type", scope.row.type, '-') }}
        </template>
      </vxe-column>
      <vxe-column
        fixed="right"
        align="center"
        width="100"
        title="操作">
        <template  slot-scope="scope">
          <!-- <el-button v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:view')" type="text" icon="el-icon-view" size="small" @click="view(scope.row.id)">查看</el-button> -->
          <!-- <el-button v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:edit')" type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.id)">修改</el-button> -->
          <!-- <el-button v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:del')" type="text"  icon="el-icon-delete" size="small" @click="del(scope.row.id)">删除</el-button> -->
            <el-button v-if="hasPermission('cecunmsetmeal:cecUnmSetMeal:view')" type="text" size="small" @click="gotoSetsMeal(scope.row)">配置套餐项目</el-button>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.total"
      :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="currentChangeHandle">
    </vxe-pager>
    </div>
    </div>
        <!-- 弹窗, 新增 / 修改 -->
    <CecUnmSetMealForm  ref="cecUnmSetMealForm" @refreshDataList="refreshList" @addTagCloud="getTagCloud"></CecUnmSetMealForm>
  </div>
</template>

<script>
  import CecUnmSetMealForm from './CecUnmSetMealForm'
  import cecUnmSetMealService from '@/api/cecunmsetmeal/cecUnmSetMealService'
  import cecUnmTagCloudService from '@/api/cecunmtagcloud/cecUnmTagCloudService'
  export default {
    data () {
      return {
        searchForm: {
          nameEn: '',
          nameCn: '',
          type: '',
          state: '',
          tagsIdsList: []
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'create_date', asc: false }]
        },
        projectSetsId: '',
        loading: false,
        stateOption: [
          { value: '0', label: '上线' },
          { value: '2', label: '草稿' },
          { value: '1', label: '下线' }
        ],
        tagList: []
      }
    },
    components: {
      CecUnmSetMealForm
    },
    activated () {
      this.getTagCloud()
      this.refreshList()
      this.projectSetsId = this.$route.query.id
    },
    methods: {
      // 获取标签数据列表
      getTagCloud () {
        cecUnmTagCloudService.list({
          'current': 1,
          'size': 1000,
          'orders': [{ column: 'create_date', asc: false }],
          'associationType': 3
        }).then(({data}) => {
          this.tagList = data.records
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmSetMealService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmSetMealForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmSetMealTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmSetMealForm.init('edit', id)
      },
      // 查看
      view (id) {
        this.$refs.cecUnmSetMealForm.init('view', id)
      },
      gotoSetsMeal (data) {
        this.$router.push({path: '/cecunmsetmeal/CecUnmSetsMealProject', query: {id: data.id, title: data.nameCn + '<详情>'}})
      },
      projectEdit (data) {
        this.$router.push({path: '/unmsets/CecUnmSetsProject', query: {id: data.setsId}})
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmSetMealTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmSetMealService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      handDropDownItem (e) {
        let stateObj = this.stateOption.find(item => item.value === e)
        this.batchOperation(stateObj)
      },
      batchOperation (data) {
        let ids = this.$refs.cecUnmSetMealTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        let query = {
          state: data.value,
          idsList: ids
        }
        this.$confirm(`确定${data.label}所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmSetMealService.batchOperation(query).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmSetMealService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmSetMealService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmSetMealService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.searchForm.tagsIdsList = []
        this.refreshList()
      }
    }
  }
</script>

<style scoped>
.point{
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}
.flex-jc-ac{
  display: flex;
  align-items: center;
  justify-content: center;
}
.yellowBack{
  background: radial-gradient(circle, rgb(249, 249, 180), yellow, #7f8131);
}
.greenBack{
  background: radial-gradient(circle, #9fe09f, #40b440, #0c360c);
}
.redBack {
  background: radial-gradient(circle, #db8d92, #e03030, #561f1f);
}
.flex-js-ac{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.point{
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}
</style>